import React from 'react';

import { MainView } from '@repo/ui/Views';

import UpdateAccountContactForm from '../components/account/UpdateAccountContact';
import CreateAccountContactForm from '../components/account/CreateAccountContactForm';
import AccountSettingsTabNav from '../components/account/AccountSettingsTabNav';
import { useQuery } from '@apollo/client/react';
import GET_PRIMARY_CONTACTS_FOR_ACCOUNT_Q from '../gql/getPrimaryContactsForAccount.gql';

import { useAccount } from '@/hooks/useAccount';
import { Card } from '@repo/ui/Card';

const AccountContact = () => {
  const currentAccount = useAccount();
  const { loading, data, error, refetch } = useQuery(GET_PRIMARY_CONTACTS_FOR_ACCOUNT_Q, {
    variables: {
      first: 1,
      id: currentAccount?.id,
    },
  });

  const accountPrimaryContact = data?.primaryContactsForAccount?.edges[0]?.node;

  return (
    <MainView title={`Manage Account:  ${currentAccount.name}`}>
      <AccountSettingsTabNav />

      <Card
        title={accountPrimaryContact ? 'Account primary contact' : 'Create account primary contact'}
        loading={loading}
        error={error}
      >
        {accountPrimaryContact ? (
          <UpdateAccountContactForm
            accountPrimaryContact={accountPrimaryContact}
            refetch={refetch}
          />
        ) : (
          <CreateAccountContactForm />
        )}
      </Card>
    </MainView>
  );
};

export default AccountContact;
